// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.sessionProvider.';

const SESSION_HALF_TIMEOUT = `${DOMAIN}processHalfTimeout`,
  SESSION_ALMOST_TIMEOUT = `${DOMAIN}processAlmostTimeout`;

export { SESSION_ALMOST_TIMEOUT, SESSION_HALF_TIMEOUT };
